export default __webpack_public_path__ + "static/media/excel-thumb-icon.8ea64a8f.svg";